import { render, staticRenderFns } from "./ConfigFinanceMain.vue?vue&type=template&id=6a51961c&"
import script from "./ConfigFinanceMain.vue?vue&type=script&lang=js&"
export * from "./ConfigFinanceMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports